import { MarketingPreferences, getMarketingPreferencesEndpoint } from 'cpie-common';
import { getSimpleDataFetchSlice } from '@cp-shared-15/frontend-integration';
import { CpDataApi } from 'cp-xhr';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';

const { reducer, fetchData } = getSimpleDataFetchSlice<MarketingPreferences, DefaultBusinessMarketApiErrorCode>({
    dataName: 'marketingPreferences',
    fetchCallback() {
        return CpDataApi.get(getMarketingPreferencesEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchMarketingPreferences = fetchData;
